import type {
    IEffectiveAccessDto,
    IPagination,
    IPermissionModel,
    IUserAuthPDPModel,
} from '@experiences/interfaces';

import { mapPagination } from '../orchestrator/TagsUtil';
import {
    get,
    post,
} from '../utility/Requests';

export async function getEffectiveAccess({
    url, pagination, payload,
}: { url: string; pagination: IPagination; payload: any }) {
    const paginationProps = mapPagination(pagination);
    const searchQueryParams = new URLSearchParams({
        top: paginationProps.take?.toString() ?? '10',
        skip: paginationProps.skip?.toString() ?? '0',
    });
    return post<IEffectiveAccessDto>(
        `${url}?${searchQueryParams.toString()}`,
        {
            body: {
                ...payload,
                roleNameStartsWith: pagination.searchTerm,
            },
            stripPortalPath: true,
        },
    );
}

export async function fetchUserAuthPDP({
    url, payload,
}: { url: string; payload: any }) {
    const response = await post<Array<{ result: IUserAuthPDPModel }> | string>(
        url,
        {
            body: payload,
            stripPortalPath: true,
        },
    );
    // On Automation Suite / dedicated the AuthZ service returns the OPA result double-serialized
    // (JSON in a string) while IsEvaluateToBytesEnabled is off there. Mirrors the server-side
    // handling in apps/server/src/routes/Utils/TenantAdminPermissionsUtil.ts.
    // Guard the parse so an unexpected non-JSON body (e.g. an HTML error page) resolves to
    // undefined rather than throwing — the same result the callers already handle.
    let parsed: Array<{ result: IUserAuthPDPModel }> | undefined;
    if (typeof response === 'string') {
        try {
            parsed = JSON.parse(response);
        } catch {
            parsed = undefined;
        }
    } else {
        parsed = response;
    }
    return parsed?.[0]?.result;
}

export async function getRoleById({ roleId }: { roleId: string }) {
    return get<IPermissionModel>(`/pap_/api/roles/${roleId}`, { stripPortalPath: true });
}
